import * as React from 'react';
import './index.scss';
import { WebAnchorItem, WebAnchorItemDesc, None, Loading, WithPage } from '@huyafed/comp';
interface Props {
  data: any,
  loading: boolean,
}
const DayRank: React.FC<Props> = (props) => (
  <div
    className='web-dayRank'
  >
    {
      props.loading ?
        <Loading from={2} />
        :
        <>
          <WebAnchorItemDesc
            width={860}
            color='#53abfd'
            descs={['排名', '主播昵称', `车技值`]}
          />
          <div className='day-List'>
            {
              props.data.length === 0 ?
                <None text={'暂无飙车日榜数据'} />
                :
                props.data.map((item: any) => (
                  <WebAnchorItem
                    key={item.tJump.lPid}
                    width={860}
                    isLarge={true}
                    color={'white'}
                    borderColor={'#53abfd'}
                    canJump={true}
                    msg={{...item, tJump: {...item.tJump, bIsLive: item.tJump.iIsLive}}}
                  />
                ))
            }
          </div>
          {props.children}
        </>
    }
  </div>
)

export default WithPage(DayRank);